module.exports = __webpack_public_path__ + "static/media/ope_katariina_768x960.f52b39a1.jpg";